import axios from "axios";
import { API_DOMAIN } from "config";

const API_BASE = String(API_DOMAIN || "").replace(/\/+$/, "");

export const uploadCarImages = async ({ carId, files = [], imageIdsToDelete = [] }) => {
  const fd = new FormData();
  fd.append("car_id", carId);

  files.forEach((file) => {
    fd.append("images[]", file);
  });

  imageIdsToDelete.forEach((id) => {
    fd.append("imagesToDelete[]", id);
  });

  return axios.post(`${API_BASE}/car/uploadImages`, fd);
};

export const uploadCarVideo = async ({ carId, videoFile }) => {
  const fd = new FormData();
  fd.append("car_id", carId);
  fd.append("video", videoFile);

  return axios.post(`${API_BASE}/car/uploadVideo`, fd);
};
